(function vimeoPlayer(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.videoPlayers = global.NewHomeSource.videoPlayers || {};
  global.NewHomeSource.videoPlayers.vimeo = global.NewHomeSource.videoPlayers.vimeo || {};

  const vimeoApi = '//player.vimeo.com/api/player.js';
  const playerInformation = { };
  const videoId = 'video-id';
  const elementId = 'element-id';
  const defaultEvents = {
    onEnded: function onEnded() { },
    onPlaying: function onPlaying() { },
    onPaused: function onPaused() { },
    onLoaded: function onLoaded() { },
  };

  let eventsHandler;
  let player;

  /**
  * @private
  * apiFilepath: returns the path where the JavaScript for the requested player can be found.
  */
  function apiFilepath() {
    return global.document.location.protocol + vimeoApi;
  }

  /**
   * @private
   * onPlaying: triggers the onPlaying event handler.
   */
  function playingHandler(data) {
    const eventData = data;
    eventData.videoId = playerInformation[videoId];
    eventsHandler.onPlaying(eventData);
  }

  function onReady() {
    if (eventsHandler.playOnLoaded) {
      player.play();
    }
  }

  /**
   * @private
   * createPlayer: creates a new Vimeo Player in the given element ID.
   */
  function createPlayer() {
    const options = {
      id: playerInformation[videoId],
    };

    if (player) {
      player.destroy();
    }

    player = new global.Vimeo.Player(playerInformation[elementId], options);
    player.on('playing', playingHandler);
    player.on('pause', eventsHandler.onPaused);
    player.on('ended', eventsHandler.onEnded);
    player.on('loaded', onReady);
  }

  /**
   * @private
   * updateVideo: loads the new video-id into the Vimeo player.
   */
  function updateVideo() {
    if (!player) {
      createPlayer();
    }

    player.loadVideo(playerInformation[videoId]);
  }

  /**
  * @private
  * loadVimeoScript: loads the Vimeo JavaScript needed for the player.
  */
  function loadVimeoScript() {
    if (typeof global.Vimeo === 'object') {
      createPlayer();
      return;
    }

    if (global.define) {
      require(
        ['vimeoPlayer'],
        (vimeoPlayerCallback) => {
          global.Vimeo = {};
          global.Vimeo.Player = vimeoPlayerCallback;
          createPlayer();
        }
      );

      return;
    }

    const tag = document.getElementsByTagName('meta')[0];
    const script = document.createElement('script');

    script.async = true;
    script.type = 'text/javascript';
    script.src = apiFilepath();
    script.onload = createPlayer;
    tag.parentNode.insertBefore(script, tag);
  }

  /**
  * @constructs VimeoPlayer
  *
  * @param {HTMLVideoElement} video element where the Vimeo player is going to be created.
  * @param {string} source id of the video to be displayed.
  * @param {object} config with the extra information needed by the player.
  */
  function Player(video, source, config) {
    playerInformation[videoId] = source;
    playerInformation[elementId] = video;
    eventsHandler = Object.assign({ }, defaultEvents, config);
    loadVimeoScript();
  }

  /**
   * @public
   * createContainer: creates an HTML element needed by the Vimeo JavaScript to create the player.
   *
   * @param {number} width of the video.
   * @param {number} height of the video.
   */
  Player.createContainer = function createContainer(width, height) {
    const videoElement = document.createElement('div');
    videoElement.setAttribute('data-vimeo-width', width);
    videoElement.setAttribute('data-vimeo-height', height);
    videoElement.setAttribute('responsive', 'true');
    videoElement.id = 'videoContainer';
    videoElement.style.width = '100%';
    videoElement.style.height = '100%';
    videoElement.innerHTML = '';
    return videoElement;
  };

  /**
  * @public
  * setVideo: changes the source of the video to the given value.
  *
  * @param {HTMLVideoElement} video element where the YouTube player is going to be created.
  * @param {string} source new video ID.
  */
  Player.setVideo = function setVideo(video, source) {
    if (source) {
      playerInformation[videoId] = source;
      playerInformation[elementId] = video;
    }

    if (!player) {
      loadVimeoScript();
      return;
    }

    updateVideo();
  };

  /**
  * @public
  * dispose: destroy the video reference for vimeo.
  *
  */
  Player.dispose = function dispose() {
    try {
      if (player) {
        player.destroy();
      }
      // eslint-disable-next-line no-empty
    } catch (error) {

    }
  };

  /**
  * @public
  * pause: pauses the vimeo video.
  *
  */
  Player.pause = function pause() {
    try {
      if (player) {
        player.pause();
      }
      // eslint-disable-next-line no-empty
    } catch (error) {

    }
  };

  /**
  * @public
  * play: plays the vimeo video.
  *
  */
  Player.play = function play() {
    try {
      if (player) {
        player.play();
      }
      // eslint-disable-next-line no-empty
    } catch (error) {

    }
  };

  global.NewHomeSource.videoPlayers.vimeo.Player = Player;
}(window));
